import React from 'react';
import Button from '../ui/Button';
import Icon from '../AppIcon';

const AlertDialog = ({ isOpen, onClose, title, message }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
            <div className="bg-card rounded-lg shadow-lg p-6 w-full max-w-sm">
                <div className="flex items-start mb-4">
                    <div className="w-10 h-10 bg-destructive/10 rounded-full flex-shrink-0 flex items-center justify-center mr-4">
                        <Icon name="AlertTriangle" size={24} className="text-destructive" />
                    </div>
                    <div className="flex-1">
                        <h2 className="text-lg font-semibold text-foreground">{title}</h2>
                        <p className="text-muted-foreground mt-1">{message}</p>
                    </div>
                </div>
                <Button onClick={onClose} fullWidth>
                    Close
                </Button>
            </div>
        </div>
    );
};

export default AlertDialog;
